import React from 'react';
import { skillsData } from '../data/mock';

const Skills = () => {
  const categories = [
    { key: 'Leadership', color: 'bg-gold-400' },
    { key: 'Business', color: 'bg-gold-300' },
    { key: 'Technical', color: 'bg-gray-400' },
    { key: 'Core', color: 'bg-gray-300' }
  ];

  const getSkillsByCategory = (category) => {
    return skillsData.filter((skill) => skill.category === category);
  };

  return (
    <section id="skills" className="py-24 bg-[#f3ede0]" data-testid="skills-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-gold-400/10 text-gold-400 text-sm font-semibold rounded-full mb-4">
            Expertise
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#152846] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Skills & <span className="text-gold-400">Competencies</span>
          </h2>
          <p className="text-lg text-[#5c6878] max-w-2xl mx-auto">
            A diverse skill set spanning leadership, business development, and technology
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {categories.map((category) => (
            <div key={category.key} className="space-y-4">
              <h3 className="text-lg font-bold text-[#152846] flex items-center gap-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                <span className={`w-3 h-3 ${category.color} rounded-full`} />
                {category.key}
              </h3>
              <div className="space-y-3">
                {getSkillsByCategory(category.key).map((skill, index) => (
                  <div
                    key={index}
                    className="group flex items-center gap-3 p-3 bg-[#fffdf8] rounded-xl border border-[#e6dfd0] hover:border-gold-400/30 transition-all duration-300 cursor-default"
                    data-testid={`skill-${skill.name.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    <div className={`w-2 h-2 ${category.color} rounded-full group-hover:scale-125 transition-transform`} />
                    <span className="text-[#3e4858] font-medium group-hover:text-gold-400 transition-colors">
                      {skill.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-12 border-t border-[#e6dfd0]">
          <h3 className="text-lg font-semibold text-[#152846] text-center mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>
            All Competencies
          </h3>
          <div className="flex flex-wrap justify-center gap-3">
            {skillsData.map((skill, index) => (
              <span
                key={index}
                className="px-4 py-2 bg-[#fffdf8] text-[#3e4858] border border-[#e6dfd0] rounded-full text-sm font-medium hover:bg-gold-400 hover:text-black hover:border-gold-400 transition-all duration-300 cursor-default"
              >
                {skill.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
